import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import AppSettingActions, { AppSettingTypes } from '../Stores/AppSetting/Actions';

const getAppStore = state => state.app;

export function* appSettingFetchAppSetting() {
  try {
    yield put(AppSettingActions.appSettingSetLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `appUpdate/list`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(AppSettingActions.appSettingFetchAppSettingSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(AppSettingActions.appSettingSetLoading(false));
  }
}

export function* appSettingUpdateAppSetting({ formikBag, newDetail }) {
  console.log('newDetail');
  console.log(newDetail);
  formikBag.setSubmitting(true);
  yield put(AppSettingActions.appSettingSetLoading(true));
  try {
    const app = yield select(getAppStore);
    const postData = {
      data: newDetail
    };

    const result = yield call(
      ApiService.putApi, // function
      app.apiUrl,
      `appUpdate/updateLinks`,
      app.token,
      postData // params
    );
    if (result.isSuccess === true) {
      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    formikBag.setSubmitting(false);
    yield put(AppSettingActions.appSettingSetLoading(false));
  }
}

export const saga = [
  takeLatest(AppSettingTypes.APP_SETTING_FETCH_APP_SETTING, appSettingFetchAppSetting),
  takeLatest(AppSettingTypes.APP_SETTING_UPDATE_APP_SETTING, appSettingUpdateAppSetting)
];
